module.exports = __webpack_public_path__ + "static/media/photo77.5a0d50e9.jpg";